<script setup>
defineProps({
  title: String,
})
</script>

<template>
  <div
    class="min-h-screen flex items-center justify-center px-4 py-8 bg-[color:var(--bg)]"
    :style="{ paddingTop: 'max(env(safe-area-inset-top), 2rem)', paddingBottom: 'max(env(safe-area-inset-bottom), 2rem)' }"
  >
    <div
      class="w-full max-w-sm rounded-[var(--radius-lg)] p-6 sm:p-8"
      :style="{ background: 'var(--surface)', border: '1px solid var(--line)', boxShadow: 'var(--shadow-md)' }"
    >
      <div class="text-center mb-6">
        <h1 class="text-2xl font-bold text-[color:var(--accent)]">Kenya2Go</h1>
        <p v-if="title" class="text-[color:var(--inkSoft)] text-sm mt-1">{{ title }}</p>
      </div>
      <slot />
    </div>
  </div>
</template>
